@use '../../styles/box-sizing';

form {
  display: flex;
  flex-direction: column;
  gap: var(--der-ui-spacing-L);

  .headline {
    font-size: var(--der-ui-font-size-general-body-reduced-bold);
    font-family: var(--der-ui-font-face-general-body-reduced-bold);
    font-style: var(--der-ui-font-style-general-body-reduced-bold);
    font-weight: var(--der-ui-font-weight-general-body-reduced-bold);
    line-height: var(--der-ui-line-height-general-body-reduced-bold);
    text-transform: var(--der-ui-text-transform-general-body-reduced-bold);
    margin-bottom: var(--der-ui-spacing-XS);
  }
  .headline__sales-sites {
    font-size: var(--der-ui-font-size-general-form-label);
    font-family: var(--der-ui-font-face-general-form-label);
    font-style: var(--der-ui-font-style-general-form-label);
    font-weight: var(--der-ui-font-weight-general-form-label);
    line-height: var(--der-ui-line-height-general-form-label);
    text-transform: var(--der-ui-text-transform-general-form-label);
    margin-bottom: var(--der-ui-spacing-5XS);
  }

  .invisible-input-wrapper {
    line-height: 0;
    display: grid;
    place-items: center;

    input {
      height: 0;
      border: 0;
      opacity: 0;
      line-height: 0;
      display: inline;
      width: 0;
    }
  }
}